import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import Notifications from '@/modules/notifications/Notifications'
import { getNotificationsThunk, markAllNotificationsReadThunk } from '@/redux/slices/notificationSlice'
import { useAppDispatch } from '@/redux/store'
import { Stack, useFocusEffect } from 'expo-router'
import { useCallback } from 'react'

export default function NotificationsPage() {
  const dispatch = useAppDispatch()

  useFocusEffect(
    useCallback(() => {
      dispatch(getNotificationsThunk({ page: 1 }))
    }, [dispatch])
  )

  const handleMarkAllReadPress = async () => {
    await dispatch(markAllNotificationsReadThunk())
  }

  return (
    <>
      <Stack.Screen
        options={{
          ...buildScreenHeaderItems({
            right: [
              {
                type: 'menu',
                label: '菜单',
                icon: {
                  type: 'sfSymbol',
                  name: 'ellipsis',
                },
                menu: {
                  items: [
                    {
                      type: 'action',
                      label: '全部标记已读',
                      onPress: handleMarkAllReadPress,
                    },
                  ],
                },
              },
            ],
          }),
        }}
      />

      <Notifications />
    </>
  )
}
